import { ComponentProps, ComponentType, FunctionComponent } from 'react';
import connect, { WithMessagesProps } from './withMessages.state';

export const withMessages = <TProps extends {}>(Component: ComponentType<TProps>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const WrappedComponent = connect(Component as any);

  WrappedComponent.displayName = `WithMessages(${WrappedComponent.displayName ||
    'Component'})`;

  return WrappedComponent as FunctionComponent<
    Omit<ComponentProps<typeof Component>, keyof WithMessagesProps>
  >;
};
